exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-bottom: 56.25%;\r\n  height: 0;\n}\n.video-wrapper iframe {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\n}\r\n", ""]);

// exports
